import { TCfgCatena, COLORE_GRAFICI_VERTICALI } from './SystemInformation.js'
import { TZMathFunct } from '@/utils/ZMathFunct.js'
import { TPointGroup } from '@/utils/ZGraph.js'

class TGruppoPunti 
{
  constructor(Punti,Data,Markup,MarkupHighlighted,Colore,ColoreAllarme,DisegnaFalda, Visibile, UltimaData = false)
  {
    this.__Punti = Punti
    this.__Markup = Markup
    this.__MarkupHighlighted = MarkupHighlighted
    this.__Data  = Data
    this.__Colore = Colore
    this.__ColoreAllarme = ColoreAllarme
    this.Visibile = Visibile
    this.__DisegnaFalda = DisegnaFalda
    this.UltimaData = UltimaData
  }
}

export class TGraficoFittizio
{
  constructor()
  {
    this.FiltroAzimuth = 0
  }

  SetMarkup()
  {
    return
  }

  AddGroupPoint()
  {
    return new TPointGroup
  }
}

export class TGraficoAttuale
{
  constructor(Catena, ObjGrafico, Differenziale, StatoAbbinati, StatoAbbinatiPiezometri)
  {
    this.__GruppiPunti = []
    this.__ObjGrafico = ObjGrafico
    this.StatoAbbinati = StatoAbbinati
    this.StatoAbbinatiPiezometri = StatoAbbinatiPiezometri
    this.MaxX = 0
    this.MaxY = 0
    this.AllineaTemperatura = false
    this.__PuntiAllineamento = null
    this.__Differenziale = Differenziale
    this.__DatiCatena = new TCfgCatena(Catena)
    this.LsFalde = []
    this.DisponiPunti()
  }

  CambiaDifferenziale()
  {
    this.__Differenziale = !this.__Differenziale
  }

  AddGruppiPunti(Punti, Data, Markup, MarkupHighlighted, Colore, ColoreAllarme, DisegnaFalda, Visibile, UltimaData)
  {
    this.__GruppiPunti.push(new TGruppoPunti(Punti,Data,Markup,MarkupHighlighted,Colore,ColoreAllarme,DisegnaFalda, Visibile, UltimaData))
  }

  AddPuntiAllineamento(Punti, Data)
  {
    this.__PuntiAllineamento = new TGruppoPunti(Punti, Data, null, null, 'transparent', 'transparent')
  }

  ClearAllGruppiPunti()
  {
    this.__GruppiPunti = []
  }

  DisponiPunti()
  {
    this.ClearAllGruppiPunti()
    for (let i = 0; i < this.__DatiCatena.Generale.Spostamenti.Date.length; i++)
    {
      let Spostamento = this.__DatiCatena.Generale.Spostamenti.Date[i]
      let Colore = Spostamento.Colore != undefined ? Spostamento.Colore : this.__DatiCatena.DatiGrafici.COLOR
      let Markup = Spostamento.Markup != undefined ? Spostamento.Markup : null
      let MarkupHighlighted = Spostamento.MarkupHighlighted != undefined ? Spostamento.MarkupHighlighted : null
      let StatoAbbinato = this.StatoAbbinati.find((element) => {return element.Data == Spostamento.Data})
      let Visibile = true
      if (StatoAbbinato != undefined)        
        Visibile = StatoAbbinato.Visibile
      //per ora il colore dell'allarme è fisso
      this.AddGruppiPunti(Spostamento.Moduli, Spostamento.Data, Markup, MarkupHighlighted, Colore, 'red', Spostamento.Falda, Visibile, Spostamento.Ultima)
    }
    if (this.__DatiCatena.Generale.Allineamento != null)
      this.AddPuntiAllineamento(this.__DatiCatena.Generale.Allineamento.Moduli, this.__DatiCatena.Generale.Allineamento.Data)
  }

  DisegnaFalda(Profondita, Modulo, GruppoPunti)
  {
    if (GruppoPunti.__DisegnaFalda)
    {
      let Falda = this.__ObjGrafico.AddOtherAxis()
      Falda.Min = this.__ObjGrafico.AxisX.Min
      Falda.Max = this.__ObjGrafico.AxisX.Max
      Falda.Inclination = 0
      Falda.Color = '#0000ff'
      Falda.DistanceFromX = Profondita
      this.LsFalde.push({Modulo : Modulo, Livello : Profondita, Data : GruppoPunti.__Data})
    }
  }

  GetCoordsPuntoInterpolato(StartCoords, CurrentCoords)
  {
    let Y = (CurrentCoords.Y + StartCoords.Y) / 2
    let X = (CurrentCoords.X + StartCoords.X) / 2
    return {X: X, Y: Y}    
  }

  RegistraPuntoInterpolato(GruppoPunti, insertBeforeIndex, Valori)
  {
    if (!GruppoPunti.__PuntiInterpolati)
      GruppoPunti.__PuntiInterpolati = []
    GruppoPunti.__PuntiInterpolati.push({
      insertBeforeIndex,
      Interpolato: true,
      ...Valori
    })
  }

  DatiSensorePerTabella(Spostamento)
  {
    return {
      Modulo: Spostamento.Modulo,
      Pitch: Spostamento.Pitch,
      Roll: Spostamento.Roll,
      Temperatura: Spostamento.Temperatura
    }
  }

  GetXPuntoIntermedio(StartCoords, CurrentCoords)
  {
    let X = (CurrentCoords.X + StartCoords.X) / 2
    return X
  }

  CompilaGraficoPolare()
  {
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let SumSpostEst  = 0
      let SumSpostNord = 0
      let SumSpostAllineatoNord = 0
      let SumSpostAllineatoEst  = 0
      let CoordsAttuali = {X: 0, Y: 0}
      let GruppoPunti = this.__GruppiPunti[i]
      GruppoPunti.__PuntiInterpolati = []
      let GruppoPuntiGrafico = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, GruppoPunti.__Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile)
      let PrecProfondita = 0
      GruppoPuntiGrafico.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)
      GruppoPuntiGrafico.AddPoint(0, 0, [])
      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      { 
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        let Allineamento = null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
          Allineamento = this.__PuntiAllineamento.__Punti[j]
        let CampioneValido = CampioneSensore.INCLINOMETRO == 'T' && Spostamento.Pitch != null && Spostamento.Roll != null //vedere se le inclinazioni sono valide (per ora lascio true)
        if (Allineamento != null)
          CampioneValido = CampioneValido && Allineamento.Pitch != null && Allineamento.Roll != null  //CampioneAllineato.InclValide
        if (CampioneValido)
        {
          if (this.__Differenziale)
          {
            SumSpostEst  = Spostamento.SpostamentoEst / 1000
            SumSpostNord = Spostamento.SpostamentoNord / 1000
            if (Allineamento != null)
            {
              SumSpostAllineatoNord = Allineamento.SpostamentoNord / 1000
              SumSpostAllineatoEst  = Allineamento.SpostamentoEst / 1000
            }
          }
          else
          {
            SumSpostEst  = SumSpostEst + Spostamento.SpostamentoEst / 1000
            SumSpostNord = SumSpostNord + Spostamento.SpostamentoNord / 1000
            if (Allineamento != null)
            {
              SumSpostAllineatoNord = SumSpostAllineatoNord + Allineamento.SpostamentoNord / 1000
              SumSpostAllineatoEst  = SumSpostAllineatoEst + Allineamento.SpostamentoEst / 1000
            }
          }
          let Hint = {}
          let CoordsPrecedenti = {X: CoordsAttuali.X, Y: CoordsAttuali.Y}
          if (j == 0 && (CampioneSensore.PROFONDITA_CODA - CampioneSensore.PROFONDITA_TESTA > 100))
          {
            PrecProfondita = CampioneSensore.PROFONDITA_CODA + 200
            CoordsPrecedenti = {X: 0, Y: 0}            
            GruppoPuntiGrafico.AddPoint(CoordsPrecedenti.X, CoordsPrecedenti.Y, {}, [], null, null, false)
          }
          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          if (Allineamento == null)
          {
            CoordsAttuali.Y = SumSpostNord
            CoordsAttuali.X = SumSpostEst
          }
          else
          {
            CoordsAttuali.Y = SumSpostNord - SumSpostAllineatoNord
            CoordsAttuali.X = SumSpostEst - SumSpostAllineatoEst
          }
          let VisualizzaNonInterpolato = true
          if (this.__DatiCatena.Generale.INTERPOLAZIONE && (PrecProfondita - CampioneSensore.PROFONDITA_CODA > 100))
          {
            let CoordsPunto = this.GetCoordsPuntoInterpolato(CoordsPrecedenti, CoordsAttuali)
            Hint.SpostNord = CoordsPunto.Y.toFixed(2)
            Hint.SpostEst  = CoordsPunto.X.toFixed(2)
            this.RegistraPuntoInterpolato(GruppoPunti, j, {
              SpostNord: Hint.SpostNord,
              SpostEst: Hint.SpostEst,
              ...this.DatiSensorePerTabella(Spostamento)
            })
            GruppoPuntiGrafico.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [2,2])
            VisualizzaNonInterpolato = false
          }
          else
          {
            Hint.SpostNord = CoordsAttuali.Y.toFixed(2)
            Hint.SpostEst  = CoordsAttuali.X.toFixed(2)
          }
          GruppoPuntiGrafico.AddPoint(CoordsAttuali.X, CoordsAttuali.Y, Hint, [], null, null, VisualizzaNonInterpolato)

          PrecProfondita = CampioneSensore.PROFONDITA_CODA
          Spostamento.SpostNord = CoordsAttuali.Y.toFixed(2)
          Spostamento.SpostEst  = CoordsAttuali.X.toFixed(2)
        }
        else
        {
          let NewProfondita = null
          if (this.__Differenziale)
          {
            if(CampioneSensore.PROFONDITA_CODA && CampioneSensore.LUNGHEZZA_SPEZZONE)
            {
              NewProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE)
              if(NewProfondita != 0)
                NewProfondita = NewProfondita / 100
            }
          }
          else 
          {
            if(CampioneSensore.PROFONDITA_TESTA)
              NewProfondita = CampioneSensore.PROFONDITA_TESTA
            if(NewProfondita != 0)
              NewProfondita = NewProfondita / 100
          }
          if(NewProfondita != null)
            Spostamento.Profondita = NewProfondita.toFixed(2)          
        }
      }
    }
  }

  CompilaGraficoSpostEst()
  {
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let SumSpostEst  = 0
      let SumSpostAllineatoEst  = 0
      let CoordsAttuali = {X: 0, Y: 0}
      let SumProfondita = this.__DatiCatena.Generale.MaxProfondita
      let PrecProfondita = 0
      let GruppoPunti = this.__GruppiPunti[i]
      GruppoPunti.__PuntiInterpolati = []
      let GruppoPuntiGrafico = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, GruppoPunti.__Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile)
      GruppoPuntiGrafico.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)

      let PuntiValidi = GruppoPunti.__Punti.filter((p, idx) => {
        let cs = this.__DatiCatena.GetCfgModuloByKey(p.Modulo)
        let valido = cs.INCLINOMETRO == 'T' && p.Pitch != null && p.Roll != null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
        {
          let all = this.__PuntiAllineamento.__Punti[idx]
          if (all != null)
            valido = valido && all.Pitch != null && all.Roll != null
        }
        return valido
      }).length


      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        let Allineamento = null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
          Allineamento = this.__PuntiAllineamento.__Punti[j]
        // if (CampioneSensore.PIEZOMETRO == 'T')
        // {
        //   let Profondita = (parseInt(CampioneSensore.PROFONDITA_CODA) * 10 - parseInt(Spostamento.Pressione)) / 1000
        //   this.DisegnaFalda(Profondita, CampioneSensore.MODULO, GruppoPunti)
        // }
        let CampioneValido = CampioneSensore.INCLINOMETRO == 'T' && Spostamento.Pitch != null && Spostamento.Roll != null

        if (Allineamento != null)
          CampioneValido = CampioneValido && Allineamento.Pitch != null && Allineamento.Roll != null //CampioneAllineato.InclValide
        if (CampioneValido)
        {
          if (PuntiValidi == 1)
          {
            GruppoPuntiGrafico.AddPoint(0, SumProfondita, {}, [], null, null, false)
          }

          if (this.__Differenziale)
          {
            SumProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE) / 100
            SumSpostEst   = Spostamento.SpostamentoEst / 1000
            if (Allineamento != null)
            {
              SumSpostAllineatoEst  = Allineamento.SpostamentoEst / 1000
            }
          }
          else
          {
            SumProfondita = CampioneSensore.PROFONDITA_TESTA / 100
            SumSpostEst  = SumSpostEst + Spostamento.SpostamentoEst / 1000
            if (Allineamento != null)
            {
              SumSpostAllineatoEst  = SumSpostAllineatoEst + Allineamento.SpostamentoEst / 1000
            }
          }
          let Hint = {}
          let CoordsPrecedenti = {X: CoordsAttuali.X, Y: CoordsAttuali.Y}
          if (j == 0 && (CampioneSensore.PROFONDITA_CODA - CampioneSensore.PROFONDITA_TESTA > 100))
          {
            PrecProfondita = CampioneSensore.PROFONDITA_CODA + 200
            CoordsPrecedenti = {X: 0, Y: CampioneSensore.PROFONDITA_CODA / 100}
            GruppoPuntiGrafico.AddPoint(CoordsPrecedenti.X, CoordsPrecedenti.Y, {}, [], null, null, false)
          }
          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          CoordsAttuali.Y = SumProfondita
          if (Allineamento == null)
            CoordsAttuali.X = SumSpostEst
          else
            CoordsAttuali.X = SumSpostEst - SumSpostAllineatoEst

          let VisualizzaNonInterpolato = true
          if (this.__DatiCatena.Generale.INTERPOLAZIONE && (PrecProfondita - CampioneSensore.PROFONDITA_CODA > 100))
          {
            let CoordsPunto = this.GetCoordsPuntoInterpolato(CoordsPrecedenti, CoordsAttuali)
            Hint.Profondita = CoordsPunto.Y.toFixed(2)
            Hint.SpostEst   = CoordsPunto.X.toFixed(2)
            this.RegistraPuntoInterpolato(GruppoPunti, j, {
              Profondita: Hint.Profondita,
              SpostEst: Hint.SpostEst,
              ...this.DatiSensorePerTabella(Spostamento)
            })
            GruppoPuntiGrafico.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [2,2])
            VisualizzaNonInterpolato = false
          }
          else
          {           
            Hint.SpostEst = CoordsAttuali.X.toFixed(2)
            Hint.Profondita = SumProfondita.toFixed(2)
          }
          PrecProfondita = CampioneSensore.PROFONDITA_CODA

          GruppoPuntiGrafico.AddPoint(CoordsAttuali.X, CoordsAttuali.Y, Hint, [], null, null, VisualizzaNonInterpolato)
          Spostamento.Profondita = CoordsAttuali.Y.toFixed(2)
          Spostamento.SpostEst = CoordsAttuali.X.toFixed(2)
        }
        else
        {
          let NewProfondita = null
          if (this.__Differenziale)
          {
            if(CampioneSensore.PROFONDITA_CODA && CampioneSensore.LUNGHEZZA_SPEZZONE)
            {
              NewProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE)
              if(NewProfondita != 0)
                NewProfondita = NewProfondita / 100
            }
          }
          else 
          {
            if(CampioneSensore.PROFONDITA_TESTA)
              NewProfondita = CampioneSensore.PROFONDITA_TESTA
            if(NewProfondita != 0)
              NewProfondita = NewProfondita / 100
          }
          if(NewProfondita != null)
            Spostamento.Profondita = NewProfondita.toFixed(2)          
        }
      }
    }
  }

  CompilaGraficoSpostNord()
  {
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let SumSpostNord  = 0
      let SumSpostAllineatoNord  = 0
      let SumProfondita = this.__DatiCatena.Generale.MaxProfondita
      let PrecProfondita = 0
      let CoordsAttuali = {X: 0, Y: 0}
      let GruppoPunti = this.__GruppiPunti[i]
      GruppoPunti.__PuntiInterpolati = []
      let GruppoPuntiGrafico = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, GruppoPunti.__Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile)
      GruppoPuntiGrafico.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)

      let PuntiValidi = GruppoPunti.__Punti.filter((p, idx) => {
        let cs = this.__DatiCatena.GetCfgModuloByKey(p.Modulo)
        let valido = cs.INCLINOMETRO == 'T' && p.Pitch != null && p.Roll != null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
        {
          let all = this.__PuntiAllineamento.__Punti[idx]
          if (all != null)
            valido = valido && all.Pitch != null && all.Roll != null
        }
        return valido
      }).length

      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        let Allineamento = null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
          Allineamento = this.__PuntiAllineamento.__Punti[j]
        // if (CampioneSensore.PIEZOMETRO == 'T')
        // {
        //   let Profondita = (CampioneSensore.PROFONDITA_CODA * 10 - Spostamento.Pressione) / 1000
        //   this.DisegnaFalda(Profondita, CampioneSensore.MODULO, GruppoPunti)
        // }
        let CampioneValido = CampioneSensore.INCLINOMETRO == 'T' && Spostamento.Pitch != null && Spostamento.Roll != null
        if (Allineamento != null)
          CampioneValido = CampioneValido && Allineamento.Pitch != null && Allineamento.Roll != null //CampioneAllineato.InclValide
        if (CampioneValido)
        {
          if (PuntiValidi == 1)
          {
            GruppoPuntiGrafico.AddPoint(0, SumProfondita, {}, [], null, null, false)
          }

          if (this.__Differenziale)
          {
            SumProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE) / 100
            SumSpostNord   = Spostamento.SpostamentoNord / 1000
            if (Allineamento != null)
              SumSpostAllineatoNord  = Allineamento.SpostamentoNord / 1000
          }
          else
          {
            SumProfondita = CampioneSensore.PROFONDITA_TESTA / 100
            SumSpostNord  = SumSpostNord + Spostamento.SpostamentoNord / 1000
            if (Allineamento != null)
              SumSpostAllineatoNord  = SumSpostAllineatoNord + Allineamento.SpostamentoNord / 1000
          }
          let Hint = {}
          let CoordsPrecedenti = {X: CoordsAttuali.X, Y: CoordsAttuali.Y}          
          
          if (j == 0 && (CampioneSensore.PROFONDITA_CODA - CampioneSensore.PROFONDITA_TESTA > 100))
          {
            PrecProfondita = CampioneSensore.PROFONDITA_CODA + 200
            CoordsPrecedenti = {X: 0, Y: CampioneSensore.PROFONDITA_CODA / 100}
            GruppoPuntiGrafico.AddPoint(CoordsPrecedenti.X, CoordsPrecedenti.Y, {}, [], null, null, false)
          }
          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          Hint.Profondita = SumProfondita.toFixed(2)
          CoordsAttuali.Y = SumProfondita
          if (Allineamento == null)
            CoordsAttuali.X = SumSpostNord 
          else
            CoordsAttuali.X = SumSpostNord - SumSpostAllineatoNord

          let VisualizzaNonInterpolato = true
          if (this.__DatiCatena.Generale.INTERPOLAZIONE && (PrecProfondita - CampioneSensore.PROFONDITA_CODA > 100))
          {
            let CoordsPunto = this.GetCoordsPuntoInterpolato(CoordsPrecedenti, CoordsAttuali)
            Hint.Profondita = CoordsPunto.Y.toFixed(2)
            Hint.SpostNord  = CoordsPunto.X.toFixed(2)
            this.RegistraPuntoInterpolato(GruppoPunti, j, {
              Profondita: Hint.Profondita,
              SpostNord: Hint.SpostNord,
              ...this.DatiSensorePerTabella(Spostamento)
            })
            GruppoPuntiGrafico.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [2,2])
            VisualizzaNonInterpolato = false
          }
          else
          {
            Hint.SpostNord = CoordsAttuali.X.toFixed(2)
            Hint.Profondita = SumProfondita.toFixed(2)
          }
          PrecProfondita = CampioneSensore.PROFONDITA_CODA

          GruppoPuntiGrafico.AddPoint(CoordsAttuali.X, CoordsAttuali.Y, Hint, [], null, null, VisualizzaNonInterpolato)
          Spostamento.Profondita = CoordsAttuali.Y.toFixed(2)
          Spostamento.SpostNord  = CoordsAttuali.X.toFixed(2)
        }
        else
        {
          let NewProfondita = null
          if (this.__Differenziale)
          {
            if(CampioneSensore.PROFONDITA_CODA && CampioneSensore.LUNGHEZZA_SPEZZONE)
            {
              NewProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE)
              if(NewProfondita != 0)
                NewProfondita = NewProfondita / 100
            }
          }
          else 
          {
            if(CampioneSensore.PROFONDITA_TESTA)
              NewProfondita = CampioneSensore.PROFONDITA_TESTA
            if(NewProfondita != 0)
              NewProfondita = NewProfondita / 100
          }
          if(NewProfondita != null)
            Spostamento.Profondita = NewProfondita.toFixed(2)          
        }
      }
    }
  }

  CompilaGraficoSpostTot()
  {
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let SumSpostNord  = 0
      let SumSpostAllineatoNord  = 0
      let SumSpostEst  = 0
      let SumSpostAllineatoEst  = 0
      let SumProfondita = this.__DatiCatena.Generale.MaxProfondita
      let PrecProfondita = 0
      let CoordsAttuali = {X: 0, Y: 0}
      let GruppoPunti = this.__GruppiPunti[i]
      GruppoPunti.__PuntiInterpolati = []
      let GruppoPuntiGrafico = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, GruppoPunti.__Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile)
      GruppoPuntiGrafico.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)
      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let SpostamentoTotale = 0
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        let Allineamento = null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
          Allineamento = this.__PuntiAllineamento.__Punti[j]
        // if (CampioneSensore.PIEZOMETRO == 'T')
        // {
        //   let Profondita = (CampioneSensore.PROFONDITA_CODA * 10 - Spostamento.Pressione) / 1000
        //   this.DisegnaFalda(Profondita, CampioneSensore.MODULO, GruppoPunti)
        // }
        let CampioneValido = CampioneSensore.INCLINOMETRO == 'T' && Spostamento.Pitch != null && Spostamento.Roll != null

        if (Allineamento != null)
          CampioneValido = CampioneValido && Allineamento.Pitch != null && Allineamento.Roll != null
        if (CampioneValido)
        {
          if (this.__Differenziale)
          {
            SumProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE) / 100
            SumSpostNord  = Spostamento.SpostamentoNord / 1000
            SumSpostEst   = Spostamento.SpostamentoEst / 1000
            
            if (Allineamento != null)
            {
              SumSpostAllineatoNord  = Allineamento.SpostamentoNord / 1000
              SumSpostAllineatoEst   = Allineamento.SpostamentoEst / 1000
            }
          }
          else
          {
            SumProfondita = CampioneSensore.PROFONDITA_TESTA / 100
            SumSpostNord  = SumSpostNord + Spostamento.SpostamentoNord / 1000
            SumSpostEst   = SumSpostEst + Spostamento.SpostamentoEst / 1000
            
            if (Allineamento != null)
            {
              SumSpostAllineatoNord  = SumSpostAllineatoNord + Allineamento.SpostamentoNord / 1000
              SumSpostAllineatoEst   = SumSpostAllineatoEst + Allineamento.SpostamentoEst / 1000
            }
          }

          if(this.__ObjGrafico.DirezioneGraficoTotale == null || this.__ObjGrafico.DirezioneGraficoTotale === '')
            SpostamentoTotale = Math.sqrt(Math.pow(SumSpostNord - SumSpostAllineatoNord, 2) + Math.pow(SumSpostEst - SumSpostAllineatoEst, 2))
          else SpostamentoTotale = this.GetSpostamentoByAngolo(SumSpostNord - SumSpostAllineatoNord, SumSpostEst - SumSpostAllineatoEst, this.__ObjGrafico.DirezioneGraficoTotale)
          
          if (SpostamentoTotale > this.MaxX)
            this.MaxX = SpostamentoTotale
          
          let Hint = {}
          let CoordsPrecedenti = {X: CoordsAttuali.X, Y: CoordsAttuali.Y}
          
          if (j == 0 && (CampioneSensore.PROFONDITA_CODA - CampioneSensore.PROFONDITA_TESTA > 100))
          {
            PrecProfondita = CampioneSensore.PROFONDITA_CODA + 200
            CoordsPrecedenti = {X: 0, Y: CampioneSensore.PROFONDITA_CODA / 100}
            GruppoPuntiGrafico.AddPoint(CoordsPrecedenti.X, CoordsPrecedenti.Y, {}, [], null, null, false)
          }

          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          CoordsAttuali.Y = SumProfondita
          CoordsAttuali.X = SpostamentoTotale

          let VisualizzaNonInterpolato = true
          if (this.__DatiCatena.Generale.INTERPOLAZIONE && (PrecProfondita - CampioneSensore.PROFONDITA_CODA > 100))
          {            
            let CoordsPunto = this.GetCoordsPuntoInterpolato(CoordsPrecedenti, CoordsAttuali)
            Hint.Profondita = CoordsPunto.Y.toFixed(2)
            Hint.SpostTotale  = CoordsPunto.X.toFixed(2)
            this.RegistraPuntoInterpolato(GruppoPunti, j, {
              Profondita: Hint.Profondita,
              SpostTotale: Hint.SpostTotale,
              ...this.DatiSensorePerTabella(Spostamento)
            })
            GruppoPuntiGrafico.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [2,2])
            VisualizzaNonInterpolato = false
          }
          else
          {
            Hint.SpostTotale = SpostamentoTotale.toFixed(2)
            Hint.Profondita = SumProfondita.toFixed(2)
          }
          PrecProfondita = CampioneSensore.PROFONDITA_CODA

          GruppoPuntiGrafico.AddPoint(CoordsAttuali.X, CoordsAttuali.Y, Hint, [], null, null, VisualizzaNonInterpolato)
          Spostamento.Profondita  = CoordsAttuali.Y.toFixed(2)
          Spostamento.SpostTotale = CoordsAttuali.X.toFixed(2)
        }
        else
        {
          let NewProfondita = null
          if (this.__Differenziale)
          {
            if(CampioneSensore.PROFONDITA_CODA && CampioneSensore.LUNGHEZZA_SPEZZONE)
            {
              NewProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE)
              if(NewProfondita != 0)
                NewProfondita = NewProfondita / 100
            }
          }
          else 
          {
            if(CampioneSensore.PROFONDITA_TESTA)
              NewProfondita = CampioneSensore.PROFONDITA_TESTA
            if(NewProfondita != 0)
              NewProfondita = NewProfondita / 100
          }
          if(NewProfondita != null)
            Spostamento.Profondita = NewProfondita.toFixed(2)          
        }
      }
    }
  }

  GetSpostamentoByAngolo(SpostNord, SpostEst, Angolo)
  {
    let SpostamentoNord = SpostNord * Math.cos(TZMathFunct.DegToRad(Angolo))
    let SpostamentoEst  = SpostEst * Math.sin(TZMathFunct.DegToRad(Angolo))

    let SpostamentoTotale = Math.sqrt(Math.pow(SpostamentoNord, 2) + Math.pow(SpostamentoEst, 2))
    
    if(SpostamentoNord + SpostamentoEst < 0)
      SpostamentoTotale *= -1

    return SpostamentoTotale
  }

  GetSpostamentoAzimuth(SpostNord, SpostEst, Roll, Pitch, Filtro)
  {
    let Result = 0
    if (SpostNord != 0 && (Math.abs(Roll) >= TZMathFunct.DegToRad(Filtro) || Math.abs(Pitch) >= TZMathFunct.DegToRad(Filtro)))
    {
      Result = Math.atan(SpostEst / SpostNord) * 180 / Math.PI
      if (SpostNord < 0 && SpostEst != 0)
        Result += 180
      if (SpostNord > 0 && SpostEst < 0)
        Result += 360
    }
    while (Result > 360)
      Result -= 360
    return Result
  }

  CompilaGraficoSpostAzimuth()
  {
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let SumSpostNord  = 0
      let SumSpostAllineatoNord  = 0
      let SumSpostEst  = 0
      let SumSpostAllineatoEst  = 0
      let SumProfondita = this.__DatiCatena.Generale.MaxProfondita
      let Azimuth = 0
      let CoordsAttuali = {X: 0, Y: 0}
      let PrecProfondita = 0
      let GruppoPunti = this.__GruppiPunti[i]
      GruppoPunti.__PuntiInterpolati = []
      let GruppoPuntiGrafico = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, GruppoPunti.__Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile)
      GruppoPuntiGrafico.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)
      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        let Allineamento = null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
          Allineamento = this.__PuntiAllineamento.__Punti[j]
        // if (CampioneSensore.PIEZOMETRO == 'T')
        // {
        //   let Profondita = (CampioneSensore.PROFONDITA_CODA * 10 - Spostamento.Pressione) / 1000
        //   this.DisegnaFalda(Profondita, CampioneSensore.MODULO, GruppoPunti)
        // }
        let CampioneValido = CampioneSensore.INCLINOMETRO == 'T' && Spostamento.Pitch != null && Spostamento.Roll != null //vedere se le inclinazioni sono valide (per ora lascio true)

        if (Allineamento != null)
          CampioneValido = CampioneValido && Allineamento.Pitch != null && Allineamento.Roll != null
        if (CampioneValido)
        {
          if (this.__Differenziale)
          {
            SumProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE) / 100
            SumSpostNord  = Spostamento.SpostamentoNord / 1000
            SumSpostEst   = Spostamento.SpostamentoEst / 1000
            if (Allineamento != null)
            {
              SumSpostAllineatoNord  = Allineamento.SpostamentoNord / 1000
              SumSpostAllineatoEst   = Allineamento.SpostamentoEst / 1000
            }
          }
          else
          {
            SumProfondita = CampioneSensore.PROFONDITA_TESTA / 100
            SumSpostNord  = SumSpostNord + Spostamento.SpostamentoNord / 1000
            SumSpostEst   = SumSpostEst + Spostamento.SpostamentoEst / 1000
            if (Allineamento != null)
            {
              SumSpostAllineatoNord  = SumSpostAllineatoNord + Allineamento.SpostamentoNord / 1000
              SumSpostAllineatoEst   = SumSpostAllineatoEst + Allineamento.SpostamentoEst / 1000
            }
          }
          // GESTIRE IL FILTRO
          Azimuth = Number((this.GetSpostamentoAzimuth(SumSpostNord - SumSpostAllineatoNord, SumSpostEst - SumSpostAllineatoEst, Spostamento.Roll, Spostamento.Pitch, this.__ObjGrafico.FiltroAzimuth)).toFixed(2))
          let Hint = {}          
          let CoordsPrecedenti = {X: CoordsAttuali.X, Y: CoordsAttuali.Y}
          
          if (j == 0 && (CampioneSensore.PROFONDITA_CODA - CampioneSensore.PROFONDITA_TESTA > 100))
          {
            // FUNZIONA COMUNQUE, MA PER CHIAREZZA FORSE SERVIREBBE METTERE UN VALORE PIù COMPRENSIBILE
            PrecProfondita = CampioneSensore.PROFONDITA_CODA + 200
            CoordsPrecedenti = {X: 0, Y: CampioneSensore.PROFONDITA_CODA / 100}            
            GruppoPuntiGrafico.AddPoint(CoordsPrecedenti.X, CoordsPrecedenti.Y, {}, [], null, null, false)
          }

          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          Hint.Profondita = SumProfondita.toFixed(2)
          CoordsAttuali.Y = SumProfondita
          CoordsAttuali.X = Azimuth

          let VisualizzaNonInterpolato = true
          if (this.__DatiCatena.Generale.INTERPOLAZIONE && (PrecProfondita - CampioneSensore.PROFONDITA_CODA > 100))
          {            
            let CoordsPunto = this.GetCoordsPuntoInterpolato(CoordsPrecedenti, CoordsAttuali)
            Hint.Profondita = CoordsPunto.Y.toFixed(2)
            Hint.Azimuth  = CoordsPunto.X.toFixed(2)
            this.RegistraPuntoInterpolato(GruppoPunti, j, {
              Profondita: Hint.Profondita,
              Azimuth: Hint.Azimuth,
              ...this.DatiSensorePerTabella(Spostamento)
            })
            GruppoPuntiGrafico.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [2,2])
            VisualizzaNonInterpolato = false
          }
          else
          {
            Hint.Azimuth = CoordsAttuali.X.toFixed(2)
            Hint.Profondita = SumProfondita.toFixed(2)
          }
          PrecProfondita = CampioneSensore.PROFONDITA_CODA

          GruppoPuntiGrafico.AddPoint(CoordsAttuali.X, CoordsAttuali.Y, Hint, [], null, null, VisualizzaNonInterpolato)
          Spostamento.Profondita = CoordsAttuali.Y.toFixed(2)
          Spostamento.Azimuth    = CoordsAttuali.X.toFixed(2)      
        }
        else
        {
          let NewProfondita = null
          if (this.__Differenziale)
          {
            if(CampioneSensore.PROFONDITA_CODA && CampioneSensore.LUNGHEZZA_SPEZZONE)
            {
              NewProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE)
              if(NewProfondita != 0)
                NewProfondita = NewProfondita / 100
            }
          }
          else 
          {
            if(CampioneSensore.PROFONDITA_TESTA)
              NewProfondita = CampioneSensore.PROFONDITA_TESTA
            if(NewProfondita != 0)
              NewProfondita = NewProfondita / 100
          }
          if(NewProfondita != null)
            Spostamento.Profondita = NewProfondita.toFixed(2)          
        }
      }
    }
  }

  CompilaGraficoTemperatura()
  {
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let Temperatura = 0
      let TemperaturaAllineata = 0
      let SumProfondita = this.__DatiCatena.Generale.MaxProfondita
      // let PrecProfondita = 0
      let CoordsAttuali = {X: 0, Y: 0}
      let GruppoPunti = this.__GruppiPunti[i]
      let GruppoPuntiGrafico = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, GruppoPunti.__Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile)
      GruppoPuntiGrafico.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)

      let PuntiValidi = GruppoPunti.__Punti.filter((p, idx) => {
        let cs = this.__DatiCatena.GetCfgModuloByKey(p.Modulo)
        let valido = cs.TERMOMETRO == 'T' && p.Temperatura != null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
        {
          let all = this.__PuntiAllineamento.__Punti[idx]
          if (all != null)
            valido = valido && all.Temperatura != null
        }
        return valido
      }).length

      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        // if (CampioneSensore.PIEZOMETRO == 'T')
        // {
        //   let Profondita = (CampioneSensore.PROFONDITA_CODA * 10 - Spostamento.Pressione) / 1000
        //   this.DisegnaFalda(Profondita, CampioneSensore.MODULO, GruppoPunti)
        // }
        // PrecProfondita = SumProfondita
        // PrecTemperatura = SumTemperatura 
        let Allineamento = null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
          Allineamento = this.__PuntiAllineamento.__Punti[j]
        let CampioneValido = CampioneSensore.TERMOMETRO == 'T' && Spostamento.Temperatura != null

        if (Allineamento != null)
          CampioneValido = CampioneValido && Allineamento.Temperatura != null
        if (CampioneValido)
        {
          SumProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE) / 100
          Spostamento.Temperatura = Number(Spostamento.Temperatura.toFixed(1))
          Temperatura = Spostamento.Temperatura
          if (Allineamento != null && this.AllineaTemperatura)       
            TemperaturaAllineata = Allineamento.Temperatura
          let Hint = {}   
          // let CoordsPrecedenti = {X: CoordsAttuali.X, Y: CoordsAttuali.Y}

          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          Hint.Profondita = SumProfondita.toFixed(2)
          CoordsAttuali.Y = SumProfondita
          
          if (Allineamento == null)
            CoordsAttuali.X = parseFloat(Temperatura)
          else
            CoordsAttuali.X = parseFloat(Temperatura - TemperaturaAllineata)          
          
          // if (j == 0 && (CampioneSensore.PROFONDITA_CODA - CampioneSensore.PROFONDITA_TESTA > 100))
          // {
            // PrecProfondita = CampioneSensore.PROFONDITA_CODA + 200
          //   CoordsPrecedenti = {X: 0, Y: CampioneSensore.PROFONDITA_CODA / 100}            
          //   GruppoPuntiGrafico.AddPoint(CoordsPrecedenti.X, CoordsPrecedenti.Y, {}, [], null, null, false)
          // }

          let VisualizzaNonInterpolato = true
          // if (this.__DatiCatena.Generale.INTERPOLAZIONE && (PrecProfondita - CampioneSensore.PROFONDITA_CODA > 100))
          // {
          //   let CoordsPunto = this.GetCoordsPuntoInterpolato(CoordsPrecedenti, CoordsAttuali)
          //   Hint.Profondita = CoordsPunto.Y.toFixed(2)
          //   Hint.Temperatura  = CoordsPunto.X.toFixed(2)
          //   GruppoPuntiGrafico.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [2,2])
          //   VisualizzaNonInterpolato = false
          // }
          // else
          // {
            Hint.Temperatura = CoordsAttuali.X.toFixed(2)
            Hint.Profondita = SumProfondita.toFixed(2)
          // }
          // PrecProfondita = CampioneSensore.PROFONDITA_CODA

          if (PuntiValidi == 1)
          {
            GruppoPuntiGrafico.AddPoint(CoordsAttuali.X, this.__DatiCatena.Generale.MaxProfondita, {}, [], null, null, false)
          }

          GruppoPuntiGrafico.AddPoint(CoordsAttuali.X, CoordsAttuali.Y, Hint, [], null, null, VisualizzaNonInterpolato)
          Spostamento.Profondita  = CoordsAttuali.Y.toFixed(2)
          // Spostamento.Temperatura = CoordsAttuali.X.toFixed(2)        
        }
        else
        {
          let NewProfondita = null
          if (this.__Differenziale)
          {
            if(CampioneSensore.PROFONDITA_CODA && CampioneSensore.LUNGHEZZA_SPEZZONE)
            {
              NewProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE)
              if(NewProfondita != 0)
                NewProfondita = NewProfondita / 100
            }
          }
          else 
          {
            if(CampioneSensore.PROFONDITA_TESTA)
              NewProfondita = CampioneSensore.PROFONDITA_TESTA
            if(NewProfondita != 0)
              NewProfondita = NewProfondita / 100
          }
          if(NewProfondita != null)
            Spostamento.Profondita = NewProfondita.toFixed(2)          
        }
      }
    }
  }

  DisponiPuntiPiezometro()
  {
    this.__ObjGrafico.ClearPiezoInfo()
    let DataPiezometroAttuale = ''

    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let GruppoPunti = this.__GruppiPunti[i]
      let StatoAbbinato = this.StatoAbbinatiPiezometri.find((element) => {return element.Data === GruppoPunti.__Data})
      let Visibile = true
      if(DataPiezometroAttuale === '' || DataPiezometroAttuale !== GruppoPunti.__Data)
        DataPiezometroAttuale = GruppoPunti.__Data
      
      if(StatoAbbinato != undefined)
      {
        Visibile = StatoAbbinato.Visibile
      }

      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        let Indice = j
        let Profondita = (CampioneSensore.PROFONDITA_CODA * 10 - Spostamento.Pressione) / 1000
        if (CampioneSensore.PIEZOMETRO == 'T' && this.__DatiCatena.Generale.TIPO_GRAFICO_PIEZOMETRO == 'S' && Spostamento.Pressione != null)
        {
          this.__ObjGrafico.AddPiezoInfo(GruppoPunti.__Data, Profondita, GruppoPunti.__Colore, this.__DatiCatena.Generale.PIEZOMETRO_DI_RIFERIMENTO == Indice, GruppoPunti.Visibile)
        }
        if (CampioneSensore.PIEZOMETRO == 'T' && this.__DatiCatena.Generale.TIPO_GRAFICO_PIEZOMETRO == 'P')
        {
          for (let i = this.__DatiCatena.Generale.Piezometro.length-1; i >= 0; i--)
          {
            let GruppoPiezometro = this.__DatiCatena.Generale.Piezometro[i]
            let MostraPiezometro = false
            let MostraInfoPiezometro

            if (GruppoPiezometro.MOSTRA_PACKER == 'T')
              MostraPiezometro = Visibile
            if(GruppoPiezometro.NASCONDI_PIEZO_INFO || GruppoPiezometro.NASCONDI_PIEZO_INFO == undefined)
              MostraInfoPiezometro = true
            else MostraInfoPiezometro = false
            let Index = parseFloat(GruppoPiezometro.NUMERO_PIEZOMETRO)

            if(GruppoPunti.__Punti[Index] && DataPiezometroAttuale == GruppoPunti.__Data)
            {
              Spostamento = GruppoPunti.__Punti[Index]
              CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
              if(Spostamento.Pressione != null)
              {
                let ProfonditaPiezometro = parseFloat(((CampioneSensore.PROFONDITA_CODA * 10 - Spostamento.Pressione) / 1000).toFixed(2))
                let PosizionePiezometro = CampioneSensore.PROFONDITA_CODA / 100
                let PressionePiezometro = ((Spostamento.Pressione / 1000) * 9.8064).toFixed(2)  // KILOPASCAL
                this.__ObjGrafico.AddPiezometroInfo(GruppoPunti.__Colore, MostraPiezometro, GruppoPiezometro.NUMERO_PIEZOMETRO, 
                                                    ProfonditaPiezometro, PosizionePiezometro, PressionePiezometro, GruppoPunti.__Data, MostraInfoPiezometro)
              }
              else
              {
                let ProfonditaPiezometro = parseFloat(((CampioneSensore.PROFONDITA_CODA * 10 - Spostamento.Pressione) / 1000).toFixed(2))
                let PosizionePiezometro = CampioneSensore.PROFONDITA_CODA / 100
                let PressionePiezometro = '- '
                let MostraSoloHint = true
                this.__ObjGrafico.AddPiezometroInfo(GruppoPunti.__Colore, MostraPiezometro, GruppoPiezometro.NUMERO_PIEZOMETRO, 
                                                    ProfonditaPiezometro, PosizionePiezometro, PressionePiezometro, GruppoPunti.__Data, MostraInfoPiezometro, MostraSoloHint)
              }
            }
          }
          for(let j = 0; j < this.__DatiCatena.Generale.Packer.length; j++)
          {
            let GruppoPacker = this.__DatiCatena.Generale.Packer[j]
            this.__ObjGrafico.AddPackerInfo(GruppoPacker.DESCRIZIONE, GruppoPacker.DALLA_PROFONDITA / 100, GruppoPacker.ALLA_PROFONDITA / 100, GruppoPacker.COLORE)
          }
          break
        }
      }
    } 
  }

  CompilaGraficoDeformazione()
  {
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let SumDeformazioni = 0
      let SumDeformazioniAllineate = 0
      // let SumProfondita = this.__DatiCatena.Generale.MaxProfondita
      // let PrecProfondita = 0
      // let PrecTemperatura = 0
      let GruppoPunti = this.__GruppiPunti[i]
      let GruppoPuntiGrafico = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, GruppoPunti.__Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile)
      let LastDeformazione = 0
      // creo il gruppo del grafico om graph
      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let LineaContinua = true
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        // PrecProfondita = SumProfondita
        // PrecTemperatura = SumTemperatura 
        let Allineamento = null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
          Allineamento = this.__PuntiAllineamento.__Punti[j]
        // if (CampioneSensore.PIEZOMETRO == 'T')
        // {
        //   let Profondita = (CampioneSensore.PROFONDITA_CODA * 10 - Spostamento.Pressione) / 1000
        //   this.DisegnaFalda(Profondita, CampioneSensore.MODULO, GruppoPunti)
        // }
        let CampioneValido = CampioneSensore.ESTENSIMETRO == 'T' && Spostamento.Deformazione != null //vedere se le inclinazioni sono valide (per ora lascio true)
        // if (CampioneSensore.LUNGHEZZA_SPEZZONE > (CampioneSensore.PROFONDITA_CODA - CampioneSensore.PROFONDITA_TESTA))
        //   LineaContinua = false
        if (Allineamento != null)
          CampioneValido = CampioneValido && Spostamento.Deformazione != null //CampioneAllineato.InclValide
        if (CampioneValido)
        {
          // SumProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE) / 100
          SumDeformazioni = Spostamento.Deformazione
          if (Allineamento != null)       
            SumDeformazioniAllineate = Allineamento.Deformazione
          let Hint = {}
          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          if (Allineamento == null)
          {
            Hint.Profondita = 'Zona da ' + parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_A).toFixed(2) + ' a ' + parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_B).toFixed(2)
            Hint.Deformazione = SumDeformazioni
            if (GruppoPuntiGrafico.__Points.length == 0)
              GruppoPuntiGrafico.AddPoint(0, CampioneSensore.SEGMENTO_DEFORMAZIONE_A, Hint, LineaContinua ? [] : [2,2], CampioneSensore.MODULO)
            GruppoPuntiGrafico.AddPoint(SumDeformazioni, CampioneSensore.SEGMENTO_DEFORMAZIONE_A, Hint, LineaContinua ? [] : [2,2], CampioneSensore.MODULO)
            GruppoPuntiGrafico.AddPoint(SumDeformazioni, CampioneSensore.SEGMENTO_DEFORMAZIONE_B, Hint, LineaContinua ? [] : [2,2], CampioneSensore.MODULO)  
          }
          else
          {
            let DeformazioneAllineata = SumDeformazioni - SumDeformazioniAllineate            
            Hint.Profondita = 'Zona deformazione da ' + parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_A).toFixed(2) + ' a ' + parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_B).toFixed(2)
            Hint.Deformazione = DeformazioneAllineata
            if (GruppoPuntiGrafico.__Points.length == 0)
              GruppoPuntiGrafico.AddPoint(0, CampioneSensore.SEGMENTO_DEFORMAZIONE_A, Hint, LineaContinua ? [] : [2,2], CampioneSensore.MODULO)
            GruppoPuntiGrafico.AddPoint(DeformazioneAllineata, CampioneSensore.SEGMENTO_DEFORMAZIONE_A, Hint, LineaContinua ? [] : [2,2], CampioneSensore.MODULO)
            GruppoPuntiGrafico.AddPoint(DeformazioneAllineata, CampioneSensore.SEGMENTO_DEFORMAZIONE_B, Hint, LineaContinua ? [] : [2,2], CampioneSensore.MODULO)  
          } 

          LastDeformazione = CampioneSensore.SEGMENTO_DEFORMAZIONE_B

          Spostamento.Deformazione = Hint.Deformazione
          Hint.Deformazione = Hint.Deformazione.toFixed()
          Spostamento.DeformazioneStart = parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_A).toFixed(2)
          Spostamento.DeformazioneStop  = parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_B).toFixed(2)
        }
        else
        {
          let NewProfondita = null
          if (this.__Differenziale)
          {
            if(CampioneSensore.PROFONDITA_CODA && CampioneSensore.LUNGHEZZA_SPEZZONE)
            {
              NewProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE)
              if(NewProfondita != 0)
                NewProfondita = NewProfondita / 100
            }
          }
          else 
          {
            if(CampioneSensore.PROFONDITA_TESTA)
              NewProfondita = CampioneSensore.PROFONDITA_TESTA
            if(NewProfondita != 0)
              NewProfondita = NewProfondita / 100
          }
          if(NewProfondita != null)
            Spostamento.Profondita = NewProfondita.toFixed(2)          
        }
      }
      let Punto = GruppoPuntiGrafico.AddPoint(0, LastDeformazione, {}, [])
      Punto.DrawMarkup = false
      let PuntoFinale = GruppoPuntiGrafico.AddPoint(0, 0, {}, [])
      PuntoFinale.DrawMarkup = false
    }
  }
  
  // -------------------------
  //    GRAFICI ORIZZONTALI
  // -------------------------

  CompilaGraficoOrizzontaleTemperatura()
  {
    let Colore = 'red'
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let Temperatura = 0
      let SumDistanza = this.__DatiCatena.Generale.MaxProfondita
      let CoordsAttuali = {X: 0, Y: 0}
      let GruppoPunti = this.__GruppiPunti[i]
      if ((this.__GruppiPunti.length > 1) || (this.__GruppiPunti.length == 1 && GruppoPunti.__Colore != COLORE_GRAFICI_VERTICALI.Grafico))
        Colore = GruppoPunti.__Colore
      let SoloAttualeVisibile = true
      this.__GruppiPunti.forEach(Gruppo => Gruppo.__Colore != COLORE_GRAFICI_VERTICALI.Grafico && Gruppo.Visibile ? SoloAttualeVisibile = false : '')
      if(SoloAttualeVisibile)
        Colore = 'red'
      let GruppoPuntiGrafico = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile)
      // if (this.__GruppiPunti.length > 1)
      //   Colore = GruppoPunti.__Colore
      GruppoPuntiGrafico.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)
      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        let CampioneValido = CampioneSensore.TERMOMETRO == 'T'

        if (CampioneValido)
        {
          SumDistanza = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE) / 100
          Temperatura = Spostamento.Temperatura
          let Hint = {}   
          let CoordsPrecedenti = {X: CoordsAttuali.X, Y: CoordsAttuali.Y}

          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          Hint.Distanza = SumDistanza.toFixed(2)
         
          CoordsAttuali.X = SumDistanza  
          CoordsAttuali.Y = parseFloat(Temperatura) 
          
          if (j == 0)
            CoordsPrecedenti.X = CampioneSensore.PROFONDITA_CODA / 100

          let CoordsPunto = {X: this.GetXPuntoIntermedio(CoordsPrecedenti, CoordsAttuali), Y: CoordsAttuali.Y}

          Hint.Distanza = CoordsPunto.X.toFixed(2)
          Hint.Temperatura  = CoordsPunto.Y.toFixed(2)
          GruppoPuntiGrafico.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [2,2], null, Colore)
        }
        else
        {
          let NewProfondita = null
          if (this.__Differenziale)
          {
            if(CampioneSensore.PROFONDITA_CODA && CampioneSensore.LUNGHEZZA_SPEZZONE)
            {
              NewProfondita = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE)
              if(NewProfondita != 0)
                NewProfondita = NewProfondita / 100
            }
          }
          else 
          {
            if(CampioneSensore.PROFONDITA_TESTA)
              NewProfondita = CampioneSensore.PROFONDITA_TESTA
            if(NewProfondita != 0)
              NewProfondita = NewProfondita / 100
          }
          if(NewProfondita != null)
            Spostamento.Profondita = NewProfondita.toFixed(2)          
        }
      }
    }
  }
  
  CompilaGraficoOrizzontaleProfiloLong()
  {    
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let GruppoPunti = this.__GruppiPunti[i]
      if (!GruppoPunti.UltimaData)
        continue
      let Temperatura = 0
      let SumDistanza = this.__DatiCatena.Generale.MaxProfondita      
      let SumSpostOrizz = 0
      let CoordsAttualiTemp  = {X: 0, Y: 0}
      let CoordsAttualiSpost = {X: 0, Y: 0}
      let AsseTemperatura = this.__ObjGrafico.GetOtherAxis(1)
      let GruppoPuntiGraficoSpost = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, GruppoPunti.__Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile, null)
      let GruppoPuntiGraficoTemp  = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, 'red', this.__ObjGrafico.PenWidth, GruppoPunti.Visibile, AsseTemperatura)
      GruppoPuntiGraficoTemp.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)
      GruppoPuntiGraficoSpost.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)
      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        let CampioneValidoTemperatura = CampioneSensore.TERMOMETRO == 'T'
        let CampioneValidoSpostamento = CampioneSensore.INCLINOMETRO == 'T'

        SumDistanza = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE) / 100

        if (CampioneValidoTemperatura)
        {
          Temperatura = Spostamento.Temperatura
          let Hint = {}   
          let CoordsPrecedenti = {X: CoordsAttualiTemp.X, Y: CoordsAttualiTemp.Y}

          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          Hint.Distanza = SumDistanza.toFixed(2)
          
          CoordsAttualiTemp.X = SumDistanza  
          CoordsAttualiTemp.Y = parseFloat(Temperatura) 
          
          if (j == 0)
            CoordsPrecedenti.X = CampioneSensore.PROFONDITA_CODA / 100
          
          let CoordsPunto = {X: this.GetXPuntoIntermedio(CoordsPrecedenti, CoordsAttualiTemp), Y: CoordsAttualiTemp.Y}
          Hint.Distanza = CoordsPunto.X.toFixed(2)
          Hint.Temperatura  = CoordsPunto.Y.toFixed(2)
          GruppoPuntiGraficoTemp.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [2,2], null)

          Spostamento.Distanza    = CoordsAttualiTemp.X// Spostamento.Distanza    = CoordsAttualiTemp.X.toFixed(2)
          Spostamento.Temperatura = CoordsAttualiTemp.Y// Spostamento.Temperatura = CoordsAttualiTemp.Y.toFixed(2)
        }
        if (CampioneValidoSpostamento)
        {
          let Hint = {}   
          let CoordsPrecedenti = {X: CoordsAttualiSpost.X, Y: CoordsAttualiSpost.Y}          
          SumSpostOrizz = SumSpostOrizz + Spostamento.SpostamentoNord / 1000

          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          Hint.Distanza = SumDistanza.toFixed(2)
          
          CoordsAttualiSpost.X = SumDistanza  
          CoordsAttualiSpost.Y = SumSpostOrizz 
          
          if (j == 0)
          {
            CoordsPrecedenti.X = CampioneSensore.PROFONDITA_CODA / 100  
            let CoordsPrimoPunto = {X: CoordsPrecedenti.X, Y: 0}
            if (this.__DatiCatena.Altro.CumulaDaUltimo)
              CoordsPrimoPunto.Y = CoordsPrimoPunto.Y - this.__DatiCatena.DatiGrafici.DatiGraficoOrizzontale.MaxMin            
            GruppoPuntiGraficoSpost.AddPoint(CoordsPrimoPunto.X, CoordsPrimoPunto.Y, {}, [], null, null, false)
          } 

          let CoordsPunto = this.GetCoordsPuntoInterpolato(CoordsPrecedenti, CoordsAttualiSpost)
          if (this.__DatiCatena.Altro.CumulaDaUltimo)
            CoordsPunto.Y = CoordsPunto.Y - this.__DatiCatena.DatiGrafici.DatiGraficoOrizzontale.MaxMin

          Hint.Distanza = CoordsPunto.X.toFixed(2)
          Hint.ProfLong = CoordsPunto.Y.toFixed(2)
          GruppoPuntiGraficoSpost.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [], null)
          Spostamento.SpostamentoOrizz = CoordsPunto.Y
        }
      }
      let CoordsUltimoPunto = {X: 0, Y: this.__DatiCatena.DatiGrafici.DatiGraficoOrizzontale.MaxMin}
      if (this.__DatiCatena.Altro.CumulaDaUltimo)
        CoordsUltimoPunto.Y = CoordsUltimoPunto.Y - this.__DatiCatena.DatiGrafici.DatiGraficoOrizzontale.MaxMin
      GruppoPuntiGraficoSpost.AddPoint(CoordsUltimoPunto.X, CoordsUltimoPunto.Y, {}, [], null, null, false)
    }
  }

  CompilaGraficoOrizzontaleProfLongAllineato()
  {
    let Colore = 'red'
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let Temperatura = 0
      let TemperaturaAllineata = 0
      let SumDistanza = this.__DatiCatena.Generale.MaxProfondita      
      let SumSpostOrizz = 0
      let SumSpostAllineatoOrizz = 0
      let CoordsAttualiTemp    = {X: 0, Y: 0}
      let CoordsAttualiSpost   = {X: 0, Y: 0}
      let LastValidSpostCoords = {X: 0, Y: 0}
      let GruppoPunti = this.__GruppiPunti[i]    
      if ((this.__GruppiPunti.length > 1) || (this.__GruppiPunti.length == 1 && GruppoPunti.__Colore != COLORE_GRAFICI_VERTICALI.Grafico))
        Colore = GruppoPunti.__Colore
      let SoloAttualeVisibile = true
      this.__GruppiPunti.forEach(Gruppo => Gruppo.__Colore != COLORE_GRAFICI_VERTICALI.Grafico && Gruppo.Visibile ? SoloAttualeVisibile = false : '')
      if(SoloAttualeVisibile)
        Colore = 'red'
      let AsseTemperatura = this.__ObjGrafico.GetOtherAxis(1)
      let GruppoPuntiGraficoSpost = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, GruppoPunti.__Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile, null)
      let GruppoPuntiGraficoTemp  = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile, AsseTemperatura)
      GruppoPuntiGraficoTemp.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)
      GruppoPuntiGraficoSpost.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)
      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        let CampioneValidoTemperatura = CampioneSensore.TERMOMETRO == 'T'
        let CampioneValidoSpostamento = CampioneSensore.INCLINOMETRO == 'T'
        let Allineamento = null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
          Allineamento = this.__PuntiAllineamento.__Punti[j]

        SumDistanza = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE) / 100

        if (CampioneValidoTemperatura)
        {
          Temperatura = Spostamento.Temperatura
          if (Allineamento != null && this.AllineaTemperatura)       
            TemperaturaAllineata = Allineamento.Temperatura
          let Hint = {}   
          let CoordsPrecedenti = {X: CoordsAttualiTemp.X, Y: CoordsAttualiTemp.Y}

          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          Hint.Distanza = SumDistanza.toFixed(2)
          
          CoordsAttualiTemp.X = SumDistanza
          if (Allineamento == null)
            CoordsAttualiTemp.Y = parseFloat(Temperatura)
          else
            CoordsAttualiTemp.Y = parseFloat(Temperatura - TemperaturaAllineata) 
          
          if (j == 0)
            CoordsPrecedenti.X = CampioneSensore.PROFONDITA_CODA / 100
          
          let CoordsPunto = {X: this.GetXPuntoIntermedio(CoordsPrecedenti, CoordsAttualiTemp), Y: CoordsAttualiTemp.Y}
          Hint.Distanza = CoordsPunto.X.toFixed(2)
          Hint.Temperatura  = CoordsPunto.Y.toFixed(2)
          GruppoPuntiGraficoTemp.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [2,2], null, Colore)
        }

        if (CampioneValidoSpostamento)
        {
          let Hint = {}   
          let CoordsPrecedenti = {X: CoordsAttualiSpost.X, Y: CoordsAttualiSpost.Y}          
          SumSpostOrizz = SumSpostOrizz + Spostamento.ProfLong / 1000

          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          if (Allineamento != null)
            SumSpostAllineatoOrizz  = SumSpostAllineatoOrizz + Allineamento.SpostamentoNord / 1000
          Hint.Distanza = SumDistanza.toFixed(2)
          
          CoordsAttualiSpost.X = SumDistanza  
          if (Allineamento == null)
            CoordsAttualiSpost.Y = SumSpostOrizz 
          else
            CoordsAttualiSpost.Y = SumSpostOrizz - SumSpostAllineatoOrizz

          LastValidSpostCoords = CoordsAttualiSpost

          if (j == 0)
          {
            CoordsPrecedenti.X = CampioneSensore.PROFONDITA_CODA / 100  
            let CoordsPrimoPunto = {X: CoordsPrecedenti.X, Y: 0}  
            GruppoPuntiGraficoSpost.AddPoint(CoordsPrimoPunto.X, CoordsPrimoPunto.Y, {}, [], null, null, false)
          } 

          let CoordsPunto = this.GetCoordsPuntoInterpolato(CoordsPrecedenti, CoordsAttualiSpost)

          Hint.Distanza = CoordsPunto.X.toFixed(2)
          Hint.ProfLong = CoordsPunto.Y.toFixed(2)
          GruppoPuntiGraficoSpost.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [], null)
          Spostamento.SpostamentoOrizz = CoordsPunto.Y
        }       
      }

      GruppoPuntiGraficoSpost.AddPoint(LastValidSpostCoords.X, LastValidSpostCoords.Y, {}, [], null, null, false)
      if (this.__DatiCatena.Altro.CumulaDaUltimo)
      {
        for (let j = 0; j < GruppoPuntiGraficoSpost.__Points.length; j++)
        {
          let SinglePunto = GruppoPuntiGraficoSpost.__Points[j]
          SinglePunto.Y = SinglePunto.Y - LastValidSpostCoords.Y;
        }
      }
    }
  }

  CompilaGraficoOrizzontaleDeformazione()
  {
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let GruppoPunti = this.__GruppiPunti[i]
      if (!GruppoPunti.UltimaData)
        continue
      let Temperatura = 0
      let SumDistanza = this.__DatiCatena.Generale.MaxProfondita      
      let SumDeformazioni = 0
      let CoordsAttualiTemp = {X: 0, Y: 0}
      let AsseTemperatura = this.__ObjGrafico.GetOtherAxis(1)
      let GruppoPuntiGraficoDef  = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, GruppoPunti.__Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile, null, null, false)
      GruppoPuntiGraficoDef.DrawMarkup = false

      let GruppoPuntiGraficoTemp = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, 'red', this.__ObjGrafico.PenWidth, GruppoPunti.Visibile, AsseTemperatura, null, true)
      GruppoPuntiGraficoTemp.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)
      GruppoPuntiGraficoTemp.CanHighlightSegment = false
      GruppoPuntiGraficoDef.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)
      // let FirstPoint = 
      GruppoPuntiGraficoDef.AddPoint(this.__DatiCatena.Generale.MaxProfondita, 0, {}, [], null, null, false)
      // FirstPoint.DrawLine = false
      
      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        let CampioneValidoTemperatura  = CampioneSensore.TERMOMETRO == 'T'
        let CampioneValidoEstensimetro = CampioneSensore.ESTENSIMETRO == 'T'

        SumDistanza = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE) / 100

        if (CampioneValidoTemperatura)
        {
          Temperatura = Spostamento.Temperatura
          let Hint = {}   
          let CoordsPrecedenti = {X: CoordsAttualiTemp.X, Y: CoordsAttualiTemp.Y}

          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          Hint.Distanza = SumDistanza.toFixed(2)
          
          CoordsAttualiTemp.X = SumDistanza  
          CoordsAttualiTemp.Y = parseFloat(Temperatura) 
          
          if (j == 0)
            CoordsPrecedenti.X = CampioneSensore.PROFONDITA_CODA / 100
          
          let CoordsPunto = {X: this.GetXPuntoIntermedio(CoordsPrecedenti, CoordsAttualiTemp), Y: CoordsAttualiTemp.Y}
          Hint.Distanza = CoordsPunto.X.toFixed(2)
          Hint.Temperatura  = CoordsPunto.Y.toFixed(2)
          GruppoPuntiGraficoTemp.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [2,2], null, null, true)

          Spostamento.Distanza    = CoordsAttualiTemp.X.toFixed(2)
          Spostamento.Temperatura = CoordsAttualiTemp.Y.toFixed(2)
        }
        if (CampioneValidoEstensimetro)
        {
          SumDeformazioni = Spostamento.Deformazione * (-1)
          let Hint = {}
          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          Hint.Profondita = 'Zona da ' + parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_A).toFixed(2) + ' a ' + parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_B).toFixed(2)
          Hint.Deformazione = SumDeformazioni
          GruppoPuntiGraficoDef.AddPoint(CampioneSensore.SEGMENTO_DEFORMAZIONE_B, 0, Hint, [], CampioneSensore.MODULO, null, false)
          GruppoPuntiGraficoDef.AddPoint(CampioneSensore.SEGMENTO_DEFORMAZIONE_B, SumDeformazioni, Hint, [], CampioneSensore.MODULO, null, false)
          GruppoPuntiGraficoDef.AddPoint(CampioneSensore.SEGMENTO_DEFORMAZIONE_A, SumDeformazioni, Hint, [], CampioneSensore.MODULO, null, false)
          // let LastPoint = 
          GruppoPuntiGraficoDef.AddPoint(CampioneSensore.SEGMENTO_DEFORMAZIONE_A, 0, Hint, [], CampioneSensore.MODULO, null, false)
          // LastPoint.DrawLine = false
          Hint.Deformazione = Hint.Deformazione.toFixed(2)
          Spostamento.DeformazioneStart = parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_A).toFixed(2)
          Spostamento.DeformazioneStop  = parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_B).toFixed(2)
        }
      }

      // let LastPoint = 
      GruppoPuntiGraficoDef.AddPoint(0, 0, {}, [], null, null, false)
      // LastPoint.DrawLine = false
    }
  }
  
  CompilaGraficoOrizzontaleDeformazioneAllineata()
  {
    let Colore = 'red'
    for (let i = 0; i < this.__GruppiPunti.length; i++)
    {
      let GruppoPunti = this.__GruppiPunti[i]
      let Temperatura = 0
      let TemperaturaAllineata = 0
      let SumDistanza = this.__DatiCatena.Generale.MaxProfondita      
      let SumDeformazioni = 0
      let CoordsAttualiTemp = {X: 0, Y: 0}
      if ((this.__GruppiPunti.length > 1) || (this.__GruppiPunti.length == 1 && GruppoPunti.__Colore != COLORE_GRAFICI_VERTICALI.Grafico))
        Colore = GruppoPunti.__Colore
      let SoloAttualeVisibile = true
      this.__GruppiPunti.forEach(Gruppo => Gruppo.__Colore != COLORE_GRAFICI_VERTICALI.Grafico && Gruppo.Visibile ? SoloAttualeVisibile = false : '')
      if(SoloAttualeVisibile)
        Colore = 'red'
      let AsseTemperatura = this.__ObjGrafico.GetOtherAxis(1)
      let GruppoPuntiGraficoDef  = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, GruppoPunti.__Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile, null, null, false)
      let GruppoPuntiGraficoTemp = this.__ObjGrafico.AddGroupPoint(GruppoPunti.__Data, Colore, this.__ObjGrafico.PenWidth, GruppoPunti.Visibile, AsseTemperatura)
      GruppoPuntiGraficoDef.DrawMarkup  = false
      GruppoPuntiGraficoTemp.DrawMarkup = true
      GruppoPuntiGraficoTemp.CanHighlightSegment = false
      GruppoPuntiGraficoTemp.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)
      GruppoPuntiGraficoDef.SetMarkup(GruppoPunti.__Markup, GruppoPunti.__MarkupHighlighted)          
      // let FirstPoint = 
      GruppoPuntiGraficoDef.AddPoint(this.__DatiCatena.Generale.MaxProfondita, 0, {}, [], null, null, false)
      // FirstPoint.DrawLine = false
      
      for (let j = 0; j < GruppoPunti.__Punti.length; j++)
      {
        let Spostamento = GruppoPunti.__Punti[j]
        let CampioneSensore = this.__DatiCatena.GetCfgModuloByKey(Spostamento.Modulo)
        let CampioneValidoTemperatura  = CampioneSensore.TERMOMETRO == 'T'
        let CampioneValidoEstensimetro = CampioneSensore.ESTENSIMETRO == 'T'
        let Allineamento = null
        if (this.__PuntiAllineamento != null && this.__PuntiAllineamento.__Punti != undefined)
          Allineamento = this.__PuntiAllineamento.__Punti[j]

        SumDistanza = (CampioneSensore.PROFONDITA_CODA - CampioneSensore.LUNGHEZZA_SPEZZONE) / 100

        if (CampioneValidoTemperatura)
        {
          Temperatura = Spostamento.Temperatura
          if (Allineamento != null && this.AllineaTemperatura)       
            TemperaturaAllineata = Allineamento.Temperatura
          let Hint = {}   
          let CoordsPrecedenti = {X: CoordsAttualiTemp.X, Y: CoordsAttualiTemp.Y}

          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          Hint.Distanza = SumDistanza.toFixed(2)
          
          CoordsAttualiTemp.X = SumDistanza  
          if (Allineamento == null)
            CoordsAttualiTemp.Y = parseFloat(Temperatura)
          else
            CoordsAttualiTemp.Y = parseFloat(Temperatura - TemperaturaAllineata) 
          
          if (j == 0)
            CoordsPrecedenti.X = CampioneSensore.PROFONDITA_CODA / 100
          
          let CoordsPunto = {X: this.GetXPuntoIntermedio(CoordsPrecedenti, CoordsAttualiTemp), Y: CoordsAttualiTemp.Y}
          Hint.Distanza = CoordsPunto.X.toFixed(2)
          Hint.Temperatura  = CoordsPunto.Y.toFixed(2)
          GruppoPuntiGraficoTemp.AddPoint(CoordsPunto.X, CoordsPunto.Y, Hint, [2,2], null, Colore)
        }
        if (CampioneValidoEstensimetro)
        {
          SumDeformazioni = Spostamento.Deformazione * (-1)
          let DeformazioneAllineata = 0
          if (Allineamento != null)
            DeformazioneAllineata = Allineamento.Deformazione * (-1)
          let Hint = {}
          Hint.Data = GruppoPunti.__Data
          Hint.Modulo = Spostamento.Modulo
          Hint.Profondita = 'Zona da ' + parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_A).toFixed(2) + 'm a ' + parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_B).toFixed(2) + 'm'
          Hint.Deformazione = SumDeformazioni

          GruppoPuntiGraficoDef.AddPoint(CampioneSensore.SEGMENTO_DEFORMAZIONE_A, 0, Hint, [], CampioneSensore.MODULO, null, false)
          GruppoPuntiGraficoDef.AddPoint(CampioneSensore.SEGMENTO_DEFORMAZIONE_A, SumDeformazioni - DeformazioneAllineata, Hint, [], CampioneSensore.MODULO, null, false)
          GruppoPuntiGraficoDef.AddPoint(CampioneSensore.SEGMENTO_DEFORMAZIONE_B, SumDeformazioni - DeformazioneAllineata, Hint, [], CampioneSensore.MODULO, null, false)
          // let LastPoint = 
          GruppoPuntiGraficoDef.AddPoint(CampioneSensore.SEGMENTO_DEFORMAZIONE_B, 0, Hint, [], CampioneSensore.MODULO, null, false)
          // LastPoint.DrawLine = false

          Hint.Deformazione = Hint.Deformazione.toFixed(2)
          Spostamento.DeformazioneStart = parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_A).toFixed(2)
          Spostamento.DeformazioneStop  = parseFloat(CampioneSensore.SEGMENTO_DEFORMAZIONE_B).toFixed(2)
        }
      }
      // GruppoPuntiGraficoTemp.DrawMarkup = true
      // let LastPoint = 
      GruppoPuntiGraficoDef.AddPoint(0, 0, {}, [], null, null, false)
      // LastPoint.DrawLine = false      
    }
  }
}